<template>
  <div id="service-side-note">
    <h3 class="title">
      預約項目
    </h3>
    <div class="content">
      <p
        v-if="step === 'notLoggedIn'"
        class="notice"
      >
        此服務僅提供給智生活社區住戶使用
      </p>
      <p
        v-if="step === 'noCommunity'"
        class="notice"
      >
        此服務僅提供給智生活社區住戶使用<br>若您尚未開通社區請前往管理室開通
      </p>
      <p
        v-if="step === 'noServiceCommunity'"
        class="notice"
      >
        您所在的智生活社區不在此服務範圍內<br>造成不便請見諒
      </p>
    </div>
    <v-btn
      v-if="step === 'notLoggedIn'"
      depressed
      color="btn primary"
      :loading="btnIsLoading"
      @click="clickLogin"
    >
      前往登入
    </v-btn>
    <div
      v-if="step === 'noCommunity'"
      class="downloads"
    >
      <a
        href="https://access.smartdaily.com.tw/launchApp.html?page=login"
        target="_blank"
        class="qrcode"
      >
        <img
          src="~/assets/image/qr-code.png"
          alt="app-qrcode"
        >
      </a>
      <div class="store">
        <a
          href="https://apps.apple.com/tw/app/id1071519372"
          target="_blank"
        >
          <img
            src="~/assets/image/app-store.svg"
            alt="app store 下載 智生活"
          >
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=chk.kingnet.app"
          target="_blank"
        >
          <img
            src="~/assets/image/google-play.svg"
            alt="gppgle play 下載 智生活"
          >
        </a>
      </div>
    </div>
    <p class="title">
      服務範圍
    </p>
    <div class="region-list">
      <div
        v-for="city in service.CityAreaList"
        :key="city.MainID"
        class="item"
      >
        <p class="city">
          {{ city.MainName }}
        </p>
        <p
          :key="`area-${city.MainID}`"
          class="area"
        >
          <span
            v-for="area in city.AreaList"
            :key="`${city.MainID}-${area.ParentPostId}`"
          >
            {{ area.ParentName }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['step'],
  data () {
    return {
      btnIsLoading: false
    }
  },
  computed: {
    service () {
      return this.$store.state.service.serviceData[parseInt(this.$nuxt.$route.params.service)]
    }
  },
  methods: {
    saveRouteAndSelectedData () {
      // 若非點擊登入/註冊 則不儲存route資料
      const savedRouteName = this.$auth.$storage?.state?.toRoute?.name
      const currentRouteName = this.$nuxt.$route.name
      if (savedRouteName === currentRouteName || !savedRouteName) {
        this.$auth.$storage.setState('toRoute', {
          name: this.$nuxt.$route.name,
          params: this.$nuxt.$route.params
        })
      }
    },
    clickLogin () {
      this.$gtm.push({
        event: 'serviceLoginStart',
        serviceName: this.service.service_title,
        pageTitle: document.title,
        pageType: 'service',
        pageUrl: this.$nuxt.$route.path,
        routeName: this.$nuxt.$route.name
      })
      this.$nuxt.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
#service-side-note {
  text-align: center;
  padding-inline: 40px;
  padding-bottom: 40px;
}
h3.title {
  padding-bottom: 12px;
  font-size: pxTorem(17px);
  line-height: pxTorem(24px);
  font-weight: bold;
  text-align: center;
  border-bottom: 3px solid $mainColor;
}
p.notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  margin-bottom: 0;
  font-weight: bold;
  text-align: center;
  color: $errorColor;
  font-size: pxTorem(18px);
  line-height: pxTorem(26px);
}
p.title {
  text-align: left;
  margin-bottom: 0;
}
.region-list {
  text-align: left;
  display: table;
  .item {
    display: table-row;
  }
  p {
    display: table-cell;
  }
  p.city {
    font-weight: bold;
    white-space: nowrap;
    padding-right: 10px;
    padding-bottom: 15px;
    padding-top: 15px;
  }
  p.area {
    word-break: keep-all;
  }
}
#service-side-note .btn {
  height: auto;
  padding: 15px 75px;
  margin-bottom: 60px;
  ::v-deep {
    span {
      font-size: pxTorem(17px);
      line-height: pxTorem(24px);
    }
  }
}
.downloads {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 60px;
  .store {
    margin-left: 15px;
    a {
      &:first-child {
        margin-bottom: 10px;
      }
    }
  }
  .qrcode {
    background-color: #fff;
    border-radius: 10px;
    img {
      max-height: 100px;
      width: auto;
    }
  }
  a {
    display: block;
  }
  img {
    display: block;
  }
}
/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .downloads {
    padding-top: 27px;
    padding-bottom: 27px;
    .qrcode {
      display: block;
      img {
        max-width: 150px;
        height: auto;
      }
    }
  }
}
</style>
